import { render } from "./Settings.vue?vue&type=template&id=6f004ba9"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"
script.render = render

export default script